import { Page } from "~/api/Api";

export interface StatusObject {
  value: string;
  label: string;
}

export const statuses = [
  "pending",
  "in_progress",
  "failed",
  "completed",
  "ignored",
  "incompatible",
  "unreachable",
  "noindex",
  "duplicate",
  "offsite",
  "excluded",
];

export const ACTIVE_STATUSES = [
  "pending",
  "in_progress",
  "failed",
  "completed",
];

export type BulkIgnoreAction = "ignore" | "include";

export const IGNORE_COMPATIBLE_PENDING_STATUSES = new Set<Page["status"]>([
  "ignored",
  "noindex",
]);

export const IGNORE_COMPATIBLE_IGNORED_STATUSES = new Set<Page["status"]>([
  "pending",
  "failed",
  "completed",
]);

export const getBulkIgnoreActionFromStatuses = (
  statuses: Page["status"][],
): BulkIgnoreAction => {
  const shouldInclude = statuses.some((status) =>
    IGNORE_COMPATIBLE_PENDING_STATUSES.has(status),
  );

  return shouldInclude ? "include" : "ignore";
};

export const formatLabel = (value: string): string =>
  value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

export const statusObjects: StatusObject[] = statuses.map((status) => ({
  value: status,
  label: formatLabel(status),
}));

export const areEqualAsSets = (a: string[], b: string[]) => {
  if (a.length !== b.length) return false;

  const setA = new Set(a);

  return b.every((x) => setA.has(x));
};

type GetItemClassArgs = {
  item: FilterOptionItem;
  isPresetSelected: boolean;
  isRealSelected: boolean;
  isPresetItem: boolean;
  styles: {
    divider: string;
    anyStatusOption: string;
    anyStatusDimmed: string;
    statusOptionBright: string;
    statusOption: string;
  };
};

interface FilterOptionItem {
  value: string;
  label: string;
  count?: number;
  isDivider?: boolean;
  className?: string;
  component?: React.ReactNode;
}

export const getItemClass = ({
  item,
  isPresetSelected,
  isRealSelected,
  isPresetItem,
  styles,
}: GetItemClassArgs): FilterOptionItem => {
  if (item.isDivider) return { ...item, className: styles.divider };

  if (isPresetSelected) {
    return {
      ...item,
      className: isPresetItem ? styles.anyStatusOption : styles.anyStatusDimmed,
    };
  }

  if (isRealSelected) {
    return {
      ...item,
      className: isPresetItem
        ? styles.anyStatusDimmed
        : styles.statusOptionBright,
    };
  }

  return { ...item, className: styles.statusOption };
};
